import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./ServicePriceFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import ServicePriceFormStepOne from "./ServicePriceFormSteps/ServicePriceFormStepOne";
import { useEffect, useState } from "react";

const ServicePriceForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (!update) {
      setInitialValues({
        ..._initialValues,
        surveyPrice: 0,
        itServicePrice: 0,
        installationPrice: 0,
        repairPrice: 0,
        diagnosticsPrice: 0,
        remotePrice: 0,
        minRateTransportPrice: 0,
        rateOneKmTransportPrice: 0,
        staticRateTransportPrice: 0,
        surveyValue: { value: "hour" },
        itServiceValue: { value: "hour" },
        repairValue: { value: "hour" },
        diagnosticsValue: { value: "hour" },
        remoteValue: { value: "hour" },
        installationValue: { value: "hour" },
      });
      return;
    }
    if (update) {
      setInitialValues({
        ..._initialValues,

        surveyValue: _initialValues?.surveyValue
          ? { value: _initialValues?.surveyValue }
          : null,
        itServiceValue: _initialValues?.itServiceValue
          ? { value: _initialValues?.itServiceValue }
          : null,
        remoteValue: _initialValues?.remoteValue
          ? { value: _initialValues?.remoteValue }
          : null,
        installationValue: _initialValues?.installationValue
          ? { value: _initialValues?.installationValue }
          : null,
        repairValue: _initialValues?.repairValue
          ? { value: _initialValues?.repairValue }
          : null,
        diagnosticsValue: _initialValues?.diagnosticsValue
          ? { value: _initialValues?.diagnosticsValue }
          : null,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="ServicePriceForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <ServicePriceFormStepOne {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default ServicePriceForm;
